export const CONFIG_COLUMN_PRICE = {
  dataIndex: 'price',
  key: 'price',
  width: 200,
};

export const CONFIG_COLUMN_STATUS = {
  dataIndex: 'status',
  key: 'status',
  width: 200,
};
